// Linien-Icons (18 px) aus dem Prototyp
import type { ReactNode } from 'react';

const Sv = ({ children, size = 18 }: { children: ReactNode; size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const IC = {
  pin: (
    <Sv>
      <path d="M12 17v5" />
      <path d="M9 3h6l-1 6 4 4H6l4-4z" />
    </Sv>
  ),
  user: (
    <Sv>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
      <path d="M19 3v4M17 5h4" />
    </Sv>
  ),
  reply: (
    <Sv>
      <path d="M9 14 4 9l5-5" />
      <path d="M4 9h11a5 5 0 0 1 5 5v6" />
    </Sv>
  ),
  replyAll: (
    <Sv>
      <path d="M11 14 6 9l5-5" />
      <path d="M6 14 1 9l5-5" />
      <path d="M6 9h10a5 5 0 0 1 5 5v6" />
    </Sv>
  ),
  fwd: (
    <Sv>
      <path d="m15 14 5-5-5-5" />
      <path d="M20 9H9a5 5 0 0 0-5 5v6" />
    </Sv>
  ),
  done: (
    <Sv>
      <circle cx="12" cy="12" r="9" />
      <path d="m8 12 3 3 5-6" />
    </Sv>
  ),
  clock: (
    <Sv>
      <circle cx="12" cy="13" r="8" />
      <path d="M12 9v4l2.5 2" />
      <path d="M5 3 2 6M19 3l3 3" />
    </Sv>
  ),
  panel: (
    <Sv>
      <rect x="3" y="4" width="18" height="16" rx="2.5" />
      <path d="M15 4v16" />
    </Sv>
  ),
  search: (
    <Sv>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </Sv>
  ),
  settings: (
    <Sv>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
    </Sv>
  ),
  unread: (
    <Sv>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </Sv>
  ),
  trash: (
    <Sv>
      <path d="M4 7h16" />
      <path d="M10 11v6M14 11v6" />
      <path d="M6 7l1 13h10l1-13" />
      <path d="M9 7V4h6v3" />
    </Sv>
  ),
  compose: (
    <Sv>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
    </Sv>
  ),
  back: (
    <Sv>
      <path d="m15 18-6-6 6-6" />
    </Sv>
  ),
  clip: (
    <Sv size={14}>
      <path d="m21 12-8.5 8.5a5 5 0 0 1-7-7L14 5a3.3 3.3 0 0 1 4.7 4.7L10 18.4a1.7 1.7 0 0 1-2.4-2.4L16 7.6" />
    </Sv>
  ),
};
